import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-save-dialog',
  templateUrl: './save-dialog.component.html',
  styleUrls: ['./save-dialog.component.scss'],
})
export class SaveDialogComponent implements OnInit {
  alertLabel: string;
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data,
    private dialogRef: MatDialogRef<SaveDialogComponent>,
    public translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.alertLabel = this.translate.instant('generic_approval.submit');
    if (this.data) {
      this.alertLabel = this.translate.instant('generic_approval.save');
    }
  }
  onSend() {
    //Kindly ensure accurate hierarchy as changes cannot be made afterward.this.translate.instant();
    // this.kmService
    //   ?.deleteFolder({
    //     privId: this.data?.privId,
    //   })
    //   .subscribe(() => {
    this.dialogRef.close(true);
    // });
  }
}
